import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '@/services/CredentialsService.js'

const HistoryHorseRiderRepository = RepositoryFactory.get('historyHorseRider')

class HistoryHorseRiderService {
  static async updateHistoryHorseRider (historyId, data) {
    try {
      return await HistoryHorseRiderRepository.updateHistoryHorseRider(CredentialsService.getCurrentTenantId(), historyId, data)
    } catch (error) {
      console.log(error)
    }
  }
}

export default HistoryHorseRiderService
